import React from "react";

interface ClientConnectionsProps {
  title: string;
  connectedClients: number;
  totalClients: number;
  recentActivity: string[];
}

const ClientConnections: React.FC<ClientConnectionsProps> = ({
  title,
  connectedClients,
  totalClients,
  recentActivity,
}) => {
  return (
    <div className="widget client-connections">
      <div className="widget-header">
        <h3>{title}</h3>
      </div>
      <div className="widget-body">
        <div className="connection-stats">
          <div className="stat-item">
            <span className="stat-label">Connected</span>
            <span className="stat-value">{connectedClients}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Total</span>
            <span className="stat-value">{totalClients}</span>
          </div>
        </div>
        <div className="activity-feed">
          <h4>Recent Activity</h4>
          <ul className="activity-list">
            {recentActivity.map((activity, index) => (
              <li key={index} className="activity-item">
                {activity}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export { ClientConnections };